var backButton = '<div class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="52" height="53" viewBox="0 0 52 53" fill="none"><path d="M17.2929 26.8682C16.9024 26.4777 16.9024 25.8446 17.2929 25.454L23.6569 19.0901C24.0474 18.6995 24.6805 18.6995 25.0711 19.0901C25.4616 19.4806 25.4616 20.1138 25.0711 20.5043L19.4142 26.1611L25.0711 31.818C25.4616 32.2085 25.4616 32.8417 25.0711 33.2322C24.6805 33.6227 24.0474 33.6227 23.6569 33.2322L17.2929 26.8682ZM36 26.1611V27.1611L18 27.1611V26.1611V25.1611L36 25.1611V26.1611Z" fill="#232323"/><circle cx="24" cy="24" r="25" transform="matrix(-1 0 0 1 50 2.16113)" stroke="#232323" stroke-width="2"/></svg></div>';
var nextButton = '<div class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="52" height="53" viewBox="0 0 52 53" fill="none"><path d="M34.7071 26.8682C35.0976 26.4777 35.0976 25.8446 34.7071 25.454L28.3431 19.0901C27.9526 18.6995 27.3195 18.6995 26.9289 19.0901C26.5384 19.4806 26.5384 20.1138 26.9289 20.5043L32.5858 26.1611L26.9289 31.818C26.5384 32.2085 26.5384 32.8417 26.9289 33.2322C27.3195 33.6227 27.9526 33.6227 28.3431 33.2322L34.7071 26.8682ZM16 26.1611V27.1611L34 27.1611V26.1611V25.1611L16 25.1611V26.1611Z" fill="#232323"/><circle cx="26" cy="26.1611" r="25" stroke="#232323" stroke-width="2"/></svg></div>';
var product_backButton = '<div class="slick-prev slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_365_74384" fill="white"><path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"/></mask><path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="white"/><path d="M-1 20C-1 8.40202 8.40202 -1 20 -1L21 -1C32.598 -1 42 8.40202 42 20H38C38 9.50659 29.9411 1 20 1C9.50659 1 1 9.50659 1 20H-1ZM42 20C42 32.1503 32.1503 42 20 42C8.40202 42 -1 32.598 -1 21L1 20C1 29.9411 9.50659 38 20 38C29.9411 38 38 29.9411 38 20H42ZM20 42C8.40202 42 -1 32.598 -1 21L-1 20C-1 8.40202 8.40202 -1 20 -1V1C9.50659 1 1 9.50659 1 20C1 29.9411 9.50659 38 20 38V42ZM21 -1C32.598 -1 42 8.40202 42 20C42 32.1503 32.1503 42 20 42V38C29.9411 38 38 29.9411 38 20C38 9.50659 29.9411 1 20 1L21 -1Z" fill="black" mask="url(#path-1-inside-1_365_74384)"/><path d="M22 27L15 20L22 13" stroke="#232323" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';
var product_nextButton = '<div class="slick-next slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_365_74386" fill="white"><path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"/></mask><path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="white"/><path d="M-1 20C-1 8.40202 8.40202 -1 20 -1H21C32.598 -1 42 8.40202 42 20H38C38 9.50659 29.9411 1 20 1C9.50659 1 1 9.50659 1 20H-1ZM42 20C42 32.1503 32.1503 42 20 42C8.40202 42 -1 32.598 -1 21L1 20C1 29.9411 9.50659 38 20 38C29.9411 38 38 29.9411 38 20H42ZM20 42C8.40202 42 -1 32.598 -1 21V20C-1 8.40202 8.40202 -1 20 -1V1C9.50659 1 1 9.50659 1 20C1 29.9411 9.50659 38 20 38V42ZM21 -1C32.598 -1 42 8.40202 42 20C42 32.1503 32.1503 42 20 42V38C29.9411 38 38 29.9411 38 20C38 9.50659 29.9411 1 20 1L21 -1Z" fill="black" mask="url(#path-1-inside-1_365_74386)"/><path d="M18 27L25 20L18 13" stroke="#232323" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';
$(document).ready(function(){
    $('.custom-collection-products').slick({
        dots: false,
        infinite: false,
        rows: 0,
        prevArrow: backButton,
        nextArrow: nextButton,
        slidesToShow: 4,
        slidesToScroll: 1,
        appendArrows: ".slider-btn",
        responsive: [
            {
            breakpoint: 1024,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 1
                }
            },
            {
            breakpoint: 749,
                settings: {
                slidesToShow: 2,
                slidesToScroll:1,
                arrows: false,
                dots: true
                }
            },
            {
            breakpoint: 600,
                settings: {
                slidesToShow: 1.2,
                slidesToScroll: 1,
                arrows: false,
                dots: true
                }
            }
        ]
    });
    $('.experiences').slick({
        dots: false,
        infinite: false,
        rows: 0,
        prevArrow: backButton,
        nextArrow: nextButton,
        slidesToShow: 4,
        slidesToScroll: 1,
        appendArrows: ".experience-btn",
        responsive: [
            {
            breakpoint: 1024,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 1
                }
            },
            {
            breakpoint: 749,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: true
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    centerMode: true,
                    centerPadding: '25px',
                    infinite:true,
                }
            }
        ]
    });

$('.experiences').on('afterChange', function(event, slick, currentSlide){
  $(".custom-opopop-experience video").each(function() {
    this.pause();
    $(this).addClass("video_controls");
  });
});

$(".custom-opopop-experience video").attr("controls", true);

$(document).on('click', '.custom-opopop-experience svg', function(e){
  e.preventDefault();
  var video = $(this).siblings("video").get(0);
  $('.custom-opopop-experience video').each(function() {
    if (this !== video) {
      this.pause();
      $(this).addClass("video_controls");
      $(this).siblings("svg").fadeIn(200);
    }
  });

  if (video.paused) {
    video.play();
  } else {
    video.pause();
  }
});
$('.custom-opopop-experience video').on('play', function() {
  var current = this;
  $('.custom-opopop-experience video').each(function() {
    if (this !== current) {
      this.pause();
      $(this).addClass("video_controls");
      $(this).siblings("svg").fadeIn(200);
    }
  });

  $(this).siblings("svg").fadeOut(200);
  $(this).removeClass("video_controls");
});

$('.custom-opopop-experience video').on('pause ended', function() {
  $(this).siblings("svg").fadeIn(200);
  $(this).addClass("video_controls");
});

$('.buy-box').on('click', function(e) {
        e.preventDefault();
        const offset = $('form.product-single__form').offset().top - 100;
        $('html, body').scrollTop(offset);
    });


    $('.our-story').slick({
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        speed: 600,
        cssEase: 'ease-in-out',
        swipeToSlide: true,
        touchThreshold: 10,
        responsive: [
        {
            breakpoint: 992,
            settings: { 
                slidesToShow: 1.5 
            }
        },
        {
            breakpoint: 600,
            settings: {
                 slidesToShow: 1,
                 centerMode: true,
                 centerPadding: '25px'
            }
        }
        ]
    });
    $('.collection-slider').slick({
        dots: false,
        infinite: false,
        rows: 0,
        prevArrow: backButton,
        nextArrow: nextButton,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
            breakpoint: 1024,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1
                }
            },
            {
            breakpoint: 749,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true
                }
            },
            {
            breakpoint: 480,
                settings: {
                slidesToShow: 1.3,
                slidesToScroll: 1,
                arrows: false,
                dots: true
                }
            }
        ]
    });
    function initTabSlider() {
        if ($('.tab-slider').hasClass('slick-initialized')) {
            $('.tab-slider').slick('unslick');
        }
        $('.tab-slider').slick({
            dots: false,
            infinite: false,
            rows: 0,
            prevArrow: backButton,
            nextArrow: nextButton,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 749,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        centerMode: true,
                        centerPadding: '25px',
                        infinite: true,
                    }
                }
            ]
        });
    }
    initTabSlider();
    $(".custom-reviews .tab").on("click", function () {
        var tab_id = $(this).attr('data-tab');
        $(".custom-reviews .tab").removeClass("active");
        $(".custom-reviews .tab-content").removeClass("active");
        $(this).addClass("active");
        $('.custom-reviews .tab-content[id="'+tab_id+'"]').addClass("active");
        initTabSlider();
    });
    function initCollectionSlider() {
        if ($('.most-loved-items').hasClass('slick-initialized')) {
            $('.most-loved-items').slick('unslick');
        }
        $('.most-loved-items').slick({
            dots: false,
            infinite: false,
            arrows: false,
            rows: 0,
            prevArrow: backButton,
            nextArrow: nextButton,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 749,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.2,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });
    }
    initCollectionSlider();
    $(".custom-most-loved .tab").on("click", function () {
        var tab_id = $(this).attr('data-tab');
        $(".custom-most-loved .tab").removeClass("active");
        $(".custom-most-loved .tab-content").removeClass("active");
        $(this).addClass("active");
        $('.custom-most-loved .tab-content[id="'+tab_id+'"]').addClass("active");
        $(".custom-most-loved .bottom-footer a.btn.cstm-btn").removeClass("active");
        $('.custom-most-loved .bottom-footer a.btn.cstm-btn[coll-btn-id="'+tab_id+'"]').addClass("active");
        initCollectionSlider();
    });
    function initSnacksSlider() {
    if ($(window).width() < 750) {
        if (!$('.snacks-slider').hasClass('slick-initialized')) {
            $('.snacks-slider').slick({
                slidesToShow: 2.1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1.2,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: true,  
                            infinite: false
                        }
                    }
                ]
            });
        }
        } else {
            if ($('.snacks-slider').hasClass('slick-initialized')) {
                $('.snacks-slider').slick('unslick');
            }
        }
    }
    initSnacksSlider();
    function initShopSlider() {
    if ($(window).width() < 750) {
        if (!$('.shop-slider').hasClass('slick-initialized')) {
            $('.shop-slider').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: true,  
                            infinite: true,
                            centerMode: true,
                            centerPadding: '25px'
                        }
                    }
                ]
            });
        }
        } else {
            if ($('.shop-slider').hasClass('slick-initialized')) {
                $('.shop-slider').slick('unslick');
            }
        }
    }
    initShopSlider();
    function initMobSlider() {
    if ($(window).width() < 750) {
        if (!$('.mob_slider .product_grid').hasClass('slick-initialized')) {
            $('.mob_slider .product_grid').slick({
                slidesToShow: 2.2,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1.06,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: false, 
                            infinite: false 
                        }
                    }
                ]
            });
        }
        } else {
            if ($('.mob_slider .product_grid').hasClass('slick-initialized')) {
                $('.mob_slider .product_grid').slick('unslick');
            }
        }
    }
    initMobSlider();
    $(window).on('resize', function () {
        initSnacksSlider();
        initShopSlider();
        initMobSlider();
    });  
    $('.custom-main-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        fade: true,
        infinite: false,
        rows: 0,
        prevArrow: product_backButton,
        nextArrow: product_nextButton,
        asNavFor: '.custom-thumb-slider',
        centerMode: false
    });
    $('.custom-thumb-slider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.custom-main-slider',
    dots: false,
    arrows: false,
    focusOnSelect: true,
    adaptiveHeight: true,
    infinite: false,
    rows: 0,
    responsive: [
        {
        breakpoint: 1240, 
        settings: {
            slidesToShow: 5,
            slidesToScroll: 1
        }
        }
    ]
    });
    $(document).on('click', '.included-hdng', function() {
        $(this).toggleClass('active');
    });
    $('.custom-accordion .accord-hdng').on('click', function() {
        const $heading = $(this);
        const $content = $heading.next('.accord-content');
        $heading.toggleClass('active');
        $content.toggleClass('open');
    });
    $('.what-includes-slider').slick({
        dots: false,
        infinite: false,
        rows: 0,
        prevArrow: backButton,
        nextArrow: nextButton,
        slidesToShow: 3.3,
        slidesToScroll: 1,
        responsive: [
            {
            breakpoint: 1024,
                settings: {
                slidesToShow: 2.3,
                slidesToScroll: 1
                }
            },
            {
            breakpoint: 480,
                settings: {
                slidesToShow: 2.1,
                slidesToScroll: 1,
                arrows: false,
                dots: true
                }
            }
        ]
    });
    var topBtn = $('.custom-collection-list .top-btn');
    topBtn.click(function() {
        $('html, body').animate({scrollTop: 0}, 500);
        return false;
    });
    
    $(document).on('click', '.site-header .right_side_collection_content .link-item span', function(){
        var value = $(this).attr('data-title');
        $('.site-header .right_collection_child_menu').hide();
        $('.site-header .inner-mega-menu').show();
        $('.site-header .inner-mega-menu .inner-mega-menu-detail[data-title="'+value+'"]').show();
    });
    $(document).on('click', '.site-header .inner-mega-menu .back-menu', function(){
        $('.site-header .right_collection_child_menu').show();
        $('.site-header .inner-mega-menu').hide();
        $('.site-header .inner-mega-menu .inner-mega-menu-detail').hide();
    });
    $(document).on('click', '.site-header .right_side_collection_content p.childlink-hdng', function(){
        const isActive = $(this).hasClass('active');
        if (!isActive) {
            $(this).addClass('active');
            $(this).parents('.collection-item').find('.link-item').show();
        }
        else{ 
            $(this).removeClass('active');
            $(this).parents('.collection-item').find('.link-item').hide();
        }
    });
    $(document).on('click', '.link-item span.mobile-grandchild-item', function(){
        var value = $(this).attr('data-title');
        var grand_child = $(this).attr('data-grand-child');
        $(this).parents('.mobile-nav__item').addClass('remove-border');
        $(this).parents('.mobile-nav__item').find('.mobile-nav__has-sublist').hide();
        $(this).parents('.mobile-nav__item').find('.mobile-nav__sublist').hide();
        $(this).parents('.mobile-nav__item').find('.mob-inner-mega-menu .mob-back-menu span.inner-menu-title').text(value);
        $(this).parents('.mobile-nav__item').find('.mob-inner-mega-menu[data-grand-child="'+grand_child+'"]').show();
        $(this).parents('.mobile-nav__item').find('.mob-inner-mega-menu .mob-inner-mega-menu-detail[data-title="'+value+'"]').show();
    });
    $(document).on('click', '.mob-inner-mega-menu .mob-back-menu', function(){
        $(this).parents('.mobile-nav__item').removeClass('remove-border');
        $('.mobile-nav__item .mobile-nav__has-sublist').show();
        $('.mobile-nav__item .mobile-nav__sublist').show();
        $('.mobile-nav__item .mob-inner-mega-menu .mob-back-menu span.inner-menu-title').empty();
        $('.mobile-nav__item .mob-inner-mega-menu').hide();
        $('.mobile-nav__item .mob-inner-mega-menu .mob-inner-mega-menu-detail').hide();
    });
});